import React from 'react';
import cx from 'classnames';

import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const ArrowUp: React.FC<Props> = ({ accessibilityLabel, className }) => (
  <i className={cx(styles.icon, className)}>
    <svg
      width={24}
      height={24}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...iconAccessibility(accessibilityLabel)}
    >
      <path
        d='M16.47 11.53l1.06-1.06L12 4.94l-5.53 5.53 1.06 1.06 3.72-3.72V18h1.5V7.81l3.72 3.72z'
        fill='currentColor'
      />
    </svg>
  </i>
);

ArrowUp.displayName = 'ArrowUp';
export default ArrowUp;
